import type { ExtractPropTypes, ExtractPublicPropTypes, PropType } from 'vue';
import type Divider from './divider.vue';

export const DividerProps = {
  direction: {
    type: String as PropType<'horizontal' | 'vertical'>,
    default: 'horizontal',
  },
  borderStyle: {
    type: String as PropType<'solid' | 'dashed' | 'dotted'>,
    default: 'solid',
  },
  contentPosition: {
    type: String as PropType<'left' | 'center' | 'right'>,
    default: 'center',
  },
  label: String,
};

export type DividerPropsType = ExtractPropTypes<typeof DividerProps>;
export type DividerPublicPropsType = ExtractPublicPropTypes<typeof DividerProps>;
export type DividerInstance = InstanceType<typeof Divider>;
